import { render, staticRenderFns } from "./ShortClosedAnswer.vue?vue&type=template&id=7f0551c8&scoped=true&"
import script from "./ShortClosedAnswer.vue?vue&type=script&lang=js&"
export * from "./ShortClosedAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ShortClosedAnswer.vue?vue&type=style&index=0&id=7f0551c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0551c8",
  null
  
)

export default component.exports